import React from 'react';
import { FadeIn } from './ui';
const timeline = [{
  day: 'Día 7',
  result: 'Notarás cómo la inflamación de tu rostro y manos desaparece.'
}, {
  day: 'Día 14',
  result: 'Tu energía por la tarde será estable, sin bajones ni antojos.'
}, {
  day: 'Día 21',
  result: 'Sentirás tu ropa más holgada en la zona de la cintura, sin haber pisado una caminadora.'
}];
export function ProofSection() {
  return <section className="bg-white py-20 px-6 md:py-28" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <FadeIn data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy text-center mb-16" data-id="element-158">
            Qué Puedes Esperar
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-159">
          {timeline.map((item, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-160">
              <div className="flex flex-col md:flex-row items-center md:items-stretch bg-cream rounded-2xl overflow-hidden shadow-sm border border-sage/30" data-id="element-161">
                <div className="bg-coral text-white py-4 px-8 md:w-48 flex items-center justify-center w-full" data-id="element-162">
                  <span className="text-2xl font-bold" data-id="element-163">{item.day}</span>
                </div>
                <div className="p-6 md:p-8 flex items-center flex-1 text-center md:text-left" data-id="element-164">
                  <p className="text-lg md:text-xl text-navy font-medium leading-relaxed" data-id="element-165">
                    {item.result}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}